<template>
  <MeetingDetailsOpenAccount
    v-if="!showDocs && showOpenAccountForm && currentMeeting && !waitingForProcess"
  />
  <MeetingDetailsInfo v-else-if="currentMeeting" />
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { formatPhone } from "@/mixins/formatPhone";
import MeetingStatusChip from "./MeetingStatusChip";
import MeetingDetailsInfo from "./MeetingDetailsInfo.vue";
import MeetingDetailsOpenAccount from "./MeetingDetailsOpenAccount.vue";

export default {
  mixins: [formatPhone],
  components: { MeetingStatusChip, MeetingDetailsInfo, MeetingDetailsOpenAccount },
  props: {
    showDocs: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    ...mapState("meeting", ["statuses", "currentMeeting", "currentMeetingId"]),
    ...mapGetters("meeting", ["showOpenAccountForm"]),

    date() {
      return this.currentMeeting ? new Date(this.currentMeeting.dadd).toLocaleDateString() : "";
    },
    time() {
      return this.currentMeeting ? new Date(this.currentMeeting.dadd).toLocaleTimeString() : "";
    },
    waitingForProcess() {
      return this.currentMeeting?.meeting_state === "process";
    },
  },

  methods: {
    ...mapActions("meeting", ["getMeetingById"]),
  },
};
</script>

<style lang="scss" scoped>
.note {
  padding: 14px 20px;
  background: #fcf2ce;
  border-radius: 3px;
  margin-bottom: 16px;
  .font--color_warning {
    color: #d2aa0f;
  }
}
.bid-details {
  background-color: #f5f5f6;
  & > div > div:first-child {
    flex-basis: 200px;

    @media (max-width: 500px) {
      flex-basis: 90px;
      margin-right: 24px;
      flex-shrink: 0;
    }
  }

  & > div > div:last-child {
    word-wrap: break-word;
    word-break: break-word;
  }
}
</style>
